import { ProfileMenu } from '@/components/profile-menu'
import { ROUTE_ACCESSED_LOGGED, ROUTE_MAIN, ROUTE_NOT_ACCESSED_LOGGED } from '@/constants/Routes'
import { useAppSelector } from '@/hooks/useRedux'
import { authSelector } from '@/pages/auth/selectors'
import React from 'react'
import { Link } from 'react-router-dom'
import { isProd } from '../../../constants/Common'
import { MenuItem, menus } from '../components'

interface Props {
  trackEvent?: (viewName: string) => void
  toggleShowDropdown: () => void
  onToggleIframe: () => void
}

export const Header = ({ trackEvent, toggleShowDropdown, onToggleIframe }: Props) => {
  const { token } = useAppSelector(authSelector)

  return (
    <div className="px-4 py-8 lg:flex hidden justify-between items-center">
      <div>
        <Link to={`${isProd ? 'https://www.dupr.com' : ROUTE_MAIN}?r=0`}>
          <img src="/img/dupr_light.svg" alt="Dreamland Universal Pickleball Ratings" className="w-24 h-7" />
        </Link>
      </div>
      <div>
        <div className="flex items-center">
          {menus.map((item) => {
            if (item.public && !item.href && item.title === 'Run Events')
              return <MenuItem key={item.title} {...item} trackEvent={trackEvent} openIFrameModal={onToggleIframe} />

            if (item.public && item.href) return <MenuItem key={item.href} {...item} trackEvent={trackEvent} />
            // isLogin
            if (token && !item.public && item.href && ROUTE_ACCESSED_LOGGED.includes(item.href))
              return <MenuItem key={item.href} {...item} />
            // is not login
            if (!token && !item.public && item.href && ROUTE_NOT_ACCESSED_LOGGED.includes(item.href))
              return <MenuItem key={item.href} {...item} trackEvent={trackEvent} />

            return <React.Fragment key={item.href} />
          })}
          {token && <ProfileMenu buttonClass="ml-2" imgClass="w-10 h-10" toggleShowDropdown={toggleShowDropdown} />}
        </div>
      </div>
    </div>
  )
}
